<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.90658 9.30274H8.25195C7.69967 9.30274 7.25195 9.75045 7.25195 10.3027C7.25195 10.855 7.69967 11.3027 8.25195 11.3027H8.36202C8.30504 11.8083 8.30511 12.3187 8.36223 12.8242H8.25195C7.69967 12.8242 7.25195 13.2719 7.25195 13.8242C7.25195 14.3765 7.69967 14.8242 8.25195 14.8242H8.90745C8.99372 15.0175 9.08948 15.2077 9.19473 15.3942L9.19684 15.3979C10.5388 17.7521 13.0799 19.162 15.7863 19.0571C16.3382 19.0357 16.7682 18.5709 16.7468 18.0191C16.7254 17.4672 16.2607 17.0372 15.7089 17.0586C13.913 17.1282 12.218 16.2775 11.1985 14.8242H15.2482C15.8005 14.8242 16.2482 14.3765 16.2482 13.8242C16.2482 13.2719 15.8005 12.8242 15.2482 12.8242H10.3804C10.2991 12.3204 10.299 11.8066 10.3801 11.3027H15.2482C15.8005 11.3027 16.2482 10.855 16.2482 10.3027C16.2482 9.75045 15.8005 9.30274 15.2482 9.30274H11.1972C12.2167 7.84874 13.9125 6.9968 15.7088 7.06647C16.2607 7.08788 16.7254 6.65786 16.7468 6.10599C16.7683 5.55412 16.3382 5.08938 15.7864 5.06798C13.0797 4.96299 10.5388 6.37386 9.19693 8.72692L9.19473 8.73079C9.08912 8.91791 8.99307 9.10878 8.90658 9.30274Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
